export default "__VITE_ASSET__BnTgDm5a__"